/* customCohorts.ts */

/* Interfaces */
import {
  BasicProps,
  LogicalProps,
} from "src/shared/interfaces/custom-cohorts/CustomCohorts";

/**
 * 'isSegment' checks if a segment is of type
 * 'LogicalProps' or 'BasicProps'.
 * 'LogicalProps' contains a logical operator (AND, OR)
 * and at least on segment of type 'BasicProps'.
 */
export const isSegment = (
  segment: LogicalProps | BasicProps
): segment is LogicalProps => {
  return (
    segment !== null &&
    typeof segment === "object" &&
    "operator" in segment &&
    "conditions" in segment
  );
};
